import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetResponse, IAgentBuyerListingsClient } from 'interfaceAdapter/gatewaySchemas/IAgentBuyerListingsClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class AgentBuyerListingsClient implements IAgentBuyerListingsClient {
    async get(input: any): Promise<IGetResponse> {
        const { token } = input;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        const params = new URLSearchParams();

        if (input.area && Array.isArray(input.area)) {
            input.area.forEach((area: string) => {
                params.append('area', area);
            });
        }

        if (input.keyword) {
            params.append('keyword', input.keyword);
        }

        // 買収希望案件の従業員数範囲
        if (input.target_company_employee_size_lower) {
            params.append('target_company_employee_size_lower', input.target_company_employee_size_lower);
        }
        if (input.target_company_employee_size_upper) {
            params.append('target_company_employee_size_upper', input.target_company_employee_size_upper);
        }

        // 買収希望案件の売上規模範囲
        if (input.target_company_revenue_scale_lower) {
            params.append('target_company_revenue_scale_lower', input.target_company_revenue_scale_lower);
        }
        if (input.target_company_revenue_scale_upper) {
            params.append('target_company_revenue_scale_upper', input.target_company_revenue_scale_upper);
        }

        // 買収希望案件の利益水準範囲
        if (input.target_company_profit_level_lower) {
            params.append('target_company_profit_level_lower', input.target_company_profit_level_lower);
        }
        if (input.target_company_profit_level_upper) {
            params.append('target_company_profit_level_upper', input.target_company_profit_level_upper);
        }

        // 買収希望案件の純資産水準範囲
        if (input.target_company_net_assets_level_lower) {
            params.append('target_company_net_assets_level_lower', input.target_company_net_assets_level_lower);
        }
        if (input.target_company_net_assets_level_upper) {
            params.append('target_company_net_assets_level_upper', input.target_company_net_assets_level_upper);
        }

        // 買収希望金額範囲
        if (input.target_company_purchase_amount_lower) {
            params.append('target_company_purchase_amount_lower', input.target_company_purchase_amount_lower);
        }
        if (input.target_company_purchase_amount_upper) {
            params.append('target_company_purchase_amount_upper', input.target_company_purchase_amount_upper);
        }

        // 買収希望案件の業種
        if (input.target_company_industries && Array.isArray(input.target_company_industries)) {
            input.target_company_industries.forEach((industry: string) => {
                params.append('target_company_industries', industry);
            });
        }

        if (input.limit) {
            params.append('limit', input.limit.toString());
        }

        if (input.offset) {
            params.append('offset', input.offset.toString());
        }

        if (input.sort) {
            params.append('sort', input.sort);
        }
        const queryString = params.toString();
        const PATH = `${API_LOCATION_URL}/agent/buyer/listings?${queryString}`;
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
